import { createUniqueFieldSchema } from '@ts-react/form'
import { z } from 'zod'
export const SmsMessageTextAreaSchema = createUniqueFieldSchema(
  z.string().max(160, { message: 'SMS message must be 160 characters or fewer' }),
  'smsMessageTextArea',
)
